import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminLivePartnersNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('live-partner');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
